import {environment} from 'environments/environment';
import {timestampChecker} from './timestampChecker'

export enum LAYERS_ID {
  WAZE_INFORMO_LAYER = 'waze_informo',
  WAZE_INFORMO_LINE_LAYER = 'waze_informo_line',
  WAZE_INFORMO_POIS_LAYER = 'waze_informo_pois',
  WAZE_INFORMO_POIS_ICONS_LAYER = 'waze_informo_pois_icons',
  MADRID_CENTRAL_LAYER = 'madrid_central',
  ZBEDEP_DISTRITO_CENTRO_POINTS_LAYER = 'zbedep_distrito_centro_points',
  ZBEDEP_DISTRITO_CENTRO_LAYER = 'zbedep_distrito_centro',
  ZBEDEP_PLAZA_ELIPTICA_POINTS_LAYER = 'zbedep_plaza_eliptica_centro_points',
  ZBEDEP_PLAZA_ELIPTICA_LAYER = 'zbedep_plaza_eliptica',
  UPCOMING_INFORMO_LAYER = 'upcoming_informo',
  DISTRICT_INFORMO_LAYER = 'disctrict_informo',
  PLATES_RESTRICTION_INFORMO_LAYER = 'plates_restrictition_informo',
  DESTINATION_INFORMO_LAYER = 'destination_informo',
  STARTING_INFORMO_LAYER = 'starting_informo',
  ROUTING_INFORMO_LAYER = 'routing_informo',
  ROUTING_INFORMO_LINE_LAYER = 'routing_informo_line',
  ROUTING_INFORMO_POIS_LAYER = 'routing_informo_pois',
};

export const LAYERS_SQL = {};

/** MADRID CENTRAL **/
LAYERS_SQL[LAYERS_ID.ZBEDEP_DISTRITO_CENTRO_LAYER] = () => {
  return `
    ${timestampChecker('zbedep_distrito_centro_limite')}
    SELECT cartodb_id, geom FROM \`${environment.carto.tablePrefix}.zbedep_distrito_centro_limite\`
  `
}

LAYERS_SQL[LAYERS_ID.ZBEDEP_DISTRITO_CENTRO_POINTS_LAYER] = () => {
  return `
    ${timestampChecker('zbedep_distrito_centro_puntos_control_acceso')}
    SELECT cartodb_id, geom FROM \`${environment.carto.tablePrefix}.zbedep_distrito_centro_puntos_control_acceso\`
  `
}

LAYERS_SQL[LAYERS_ID.ZBEDEP_PLAZA_ELIPTICA_LAYER] = () => {
  return `
    ${timestampChecker('zbedep_plaza_eliptica_limite')}
    SELECT cartodb_id, geom FROM \`${environment.carto.tablePrefix}.zbedep_plaza_eliptica_limite\`
  `
}

LAYERS_SQL[LAYERS_ID.ZBEDEP_PLAZA_ELIPTICA_POINTS_LAYER] = () => {
  return `
    ${timestampChecker('zbedep_plaza_eliptica_puntos_control_acceso')}
    SELECT cartodb_id, geom FROM \`${environment.carto.tablePrefix}.zbedep_plaza_eliptica_puntos_control_acceso\`
  `
}

/** WAZE **/
LAYERS_SQL[LAYERS_ID.WAZE_INFORMO_LINE_LAYER] = () => {
  return `
    ${timestampChecker('madrid_traffic_servicelevels')}
    ${timestampChecker('madrid_traffic_intensity_lines')}
    SELECT
      ROW_NUMBER() OVER() as cartodb_id, geom, source,
      layer, type, level, street, roadlength, speed, delay, status, intensity
    FROM (
      (SELECT geom, 'informo' as source,
        'SERVICE_LEVELS' as layer, NULL as type, NULL as level, NULL as street,
        NULL as roadlength, NULL as speed, NULL as delay, status, NULL as intensity
      FROM \`${environment.carto.tablePrefix}.madrid_traffic_servicelevels\`)
      UNION ALL
      (SELECT geom, 'informo' as source,
        'INTENSITY_LEVELS' as layer, NULL as type, NULL as level, NULL as street,
        NULL as roadlength, NULL as speed, NULL as delay, NULL as status, intensity
      FROM \`${environment.carto.tablePrefix}.madrid_traffic_intensity_lines\`)
    ) _q
  `
}

LAYERS_SQL[LAYERS_ID.WAZE_INFORMO_POIS_LAYER] = () => {
  return  `
    ${timestampChecker('madrid_traffic_tlights_acustw')}
    ${timestampChecker('madrid_traffic_incidences')}
    ${timestampChecker('madrid_traffic_cameras')}
    ${timestampChecker('madrid_traffic_tlights_red')}
    SELECT
    ROW_NUMBER() OVER() as cartodb_id, geom, source,
    layer, type, level, street, roadlength, speed, delay,
    UNIX_SECONDS(time_start) as time_start,
    UNIX_SECONDS(time_finish) as time_finish,
    description, subtype, type_level, cod_id, url, created_at, active, is_foreseen, is_planned
    FROM (
      (
        SELECT geom, 'informo' as source,
        'ACOUSTIC_WARNINGS' as layer, 'ACOUSTIC_WARNINGS' as type, NULL as level, CONCAT(latitud, ',', longitud)  as street,
        NULL as roadlength, NULL as speed,
        NULL as delay, NULL as time_start, NULL as time_finish,
        NULL as description, tipo_elem as subtype, NULL as type_level,
        NULL as cod_id, NULL as url, NULL as created_at, NULL as active,
        NULL as is_foreseen, NULL as is_planned
      FROM \`${environment.carto.tablePrefix}.madrid_traffic_tlights_acustw\`
      )
      UNION ALL
      (
          SELECT geom, 'informo' as source,
            'ALERTS' as layer, CASE
              WHEN type = 'CONSTRUCTION' THEN 'CONSTRUCTION'
              WHEN type = 'ACCIDENT' THEN 'ACCIDENT'
              WHEN type = 'ALERT' THEN 'WEATHERHAZARD'
              WHEN type = 'EVENT' THEN 'EVENT'
              WHEN type = 'PREVISION' THEN 'PREVISION'
            END as type, NULL as level, NULL as street, NULL as roadlength,
            NULL as speed, NULL as delay,
            start as time_start, finish as time_finish, description,
            NULL as subtype,
            type || '-madrid' as type_level,
            NULL as cod_id, NULL as url, NULL as created_at, NULL as active,
            is_foreseen, is_planned
          FROM \`${environment.carto.tablePrefix}.madrid_traffic_incidences\`
      )
      UNION ALL
      (
        SELECT geom, 'informo' as source, 'CAMERA' as layer,
        'CAMERA' as type, NULL as level, name as street,
        NULL as roadlength, NULL as speed,
        NULL as delay, NULL as time_start, NULL as time_finish,
        NULL as description, NULL as subtype, NULL as type_level, cod_id, url, created_at,
        NULL as active, NULL as is_foreseen, NULL as is_planned
      FROM \`${environment.carto.tablePrefix}.madrid_traffic_cameras\`
      )
      UNION ALL
      (
        SELECT geom, 'informo' as source, 'TRAFFIC_LIGHT' as layer,
        'TRAFFIC_LIGHT' as type, NULL as level, nombre as street, NULL as roadlength,
        NULL as speed, NULL as delay,
        NULL as time_start, NULL as time_finish,
        NULL as description, NULL as subtype, NULL as type_level,
        CASE WHEN CAST(distrito AS INT64) <= 9
          THEN 0 || distrito
          ELSE distrito
        END || id_cruce as cod_id, NULL as url, NULL as created_at, activo as active,
        NULL as is_foreseen, NULL as is_planned
      FROM \`${environment.carto.tablePrefix}.madrid_traffic_tlights_red\`
      )
    ) _q
  `
}


/** UPCOMING **/
LAYERS_SQL[LAYERS_ID.UPCOMING_INFORMO_LAYER] = () => {
  return `
    ${timestampChecker('madrid_traffic_incidences')}
    SELECT id AS cartodb_id, geom, 'informo' as source,
      UNIX_SECONDS(start) as start_timestamp, UNIX_SECONDS(finish) as finish_timestamp, description as reportdescription,
      'PREVISION' as type,
      CASE
        WHEN start >= CURRENT_TIMESTAMP() THEN 'future'
        WHEN start < CURRENT_TIMESTAMP() AND finish >= CURRENT_TIMESTAMP() THEN 'current'
      END as status
    FROM \`${environment.carto.tablePrefix}.madrid_traffic_incidences\`
    WHERE start >= CURRENT_TIMESTAMP()
  `
}

LAYERS_SQL[LAYERS_ID.DISTRICT_INFORMO_LAYER] = () => {
  return `
    ${timestampChecker('madrid_traffic_districts_pond_v')}
    select cartodb_id, geom, name, pond from \`${environment.carto.tablePrefix}.madrid_traffic_districts_pond_v\`
  `
}

/** PLATES **/
LAYERS_SQL[LAYERS_ID.PLATES_RESTRICTION_INFORMO_LAYER] = () => {
  return `
    ${timestampChecker('termino_municipal_polygon')}
    ${timestampChecker('contornom30')}
    ${timestampChecker('zbedep_distrito_centro_limite')}
    ${timestampChecker('zbedep_plaza_eliptica_limite')}
    select cartodb_id, geom, layerType from (
        select
          0 as cartodb_id,
          geom,
          'termino_municipal' as layerType
        from \`${environment.carto.tablePrefix}.termino_municipal_polygon\`
        UNION ALL
        select
          2 as cartodb_id,
          geom,
          'contornom30' as layerType
        from \`${environment.carto.tablePrefix}.contornom30\`
        UNION ALL
        select
          4 as cartodb_id,
          geom,
          'zbedep_distrito_centro_limite' as layerType
        from \`${environment.carto.tablePrefix}.zbedep_distrito_centro_limite\`
        UNION ALL
          select
            3 as cartodb_id,
            geom,
            'zbedep_plaza_eliptica_limite' as layerType
          from \`${environment.carto.tablePrefix}.zbedep_plaza_eliptica_limite\`
      ) as _polygons order by cartodb_id desc
  `
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/layers/constants.ts